import request from './service/index';
// news topic下拉 列表查询  
export function getTopics_Api(){
    return request({
        url:'CMS/tools/news_topic_drop_down',
        method:'get'
    });
}

// newslist
export function newsSearch_Api(data){//查询列表
    return request({
        url:'CMS/news/news_list',
        method:'post',
        data:data
    });
}
export function deleteNewsList_Api(data){//批量删除
    return request({
        url:'CMS/news/news_list',
        method:'delete',
        data:data
    })
}

// news detail
export function updateNews_Api(data){//更新
    return request({
        url:'CMS/news/news_detail',
        method:'put',
        data:data
    })
}
export function addNews_Api(data){//增加
    return request({
        url:'CMS/news/news_detail',
        method:'post',
        data:data
    })
}
export function getNewsDetial_Api(id){//查询
    return request({
        url:`CMS/news/news_detail?news_id=${id}`,
        method:'get'
    })
}

// news 数量
export function getNewsCount_Api(){
    return request({
        url:'CMS/news/news_count',
        method:'get'
    })
}

// 清除失效新闻
export function cleanNews_Api(){
    return request({
        url:'CMS/news/clean',
        method:'get'
    })
}

// 导出新闻数据
export function outputNews_Api(data){
    return request({
        url:'CMS/news/output',
        method:'post',
        data:data,
        responseType: 'arraybuffer',
    })
}

// 列表查询 
export function getNewsTopics_Api(){
    return request({
        url:`/CMS/news/topic`,
        method:'get'
    });
}
export function deleteNewsTopics_Api(data){
    return request({
        url:`/CMS/news/topic`,
        method:'delete',
        data:data
    });
}
export function addNewsTopics_Api(data){
    return request({
        url:`/CMS/news/topic`,
        method:'post',
        data:data
    })
}
export function updateNewsTopics_Api(data){
    return request({
        url:`/CMS/news/topic`,
        method:'put',
        data:data
    })
}

export function getRegisterField_Api(){
    return request({
        url:`CMS/news/evnet_register_fields`,
    })
}

// 导出报名信息
export function outputRegister_Api(data){
    return request({
        url:'CMS/news/register_form_output',
        method:'post',
        data:data,
        responseType: 'arraybuffer',
    })
}
 



// WEBPACK FOOTER //
// ./src/apis/news.api.js